import { GET_EVENT, GET_EVENT_SIGNUPS } from "../../services/endpoints";

import axiosAPI from "../../services/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import cuid from "cuid";

export const getEvent = createAsyncThunk(
  "event",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getEventSignups = createAsyncThunk(
  "event/signups",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT_SIGNUPS(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const refreshEventSignups = createAsyncThunk(
  "event/signups/refresh",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT_SIGNUPS(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const refreshEvent = createAsyncThunk(
  "event/refresh",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
